import { memo, useEffect, useState } from 'react';

import { Display } from '@/components/Display/Display';
import { Popover } from 'antd';
import { isApartSkillActive } from '@/utils/Page';
import MyIcon from '@/components/MyIcon';
import ActiveImg from './ActiveImg';
import './apart.scss';
const RenderList = ({ list, handleSetCurSkill, curSkill, isNewChat, isInMore = false, isInChat }) => {
    return list.map((item, index) => {
        const isActive = isInChat ? isApartSkillActive(curSkill, item, isNewChat, false) : false;
        return (
            <div className={'list-item'} data-active={isActive} key={index} onClick={() => handleSetCurSkill(item)}>
                <span className="skill-name">
                    <MyIcon className="skill-icon" type={item.ability_icon || 'icon-skill-icon1'}></MyIcon>

                    {item.ability_name}
                </span>
                <Display show={isInMore && isActive}>
                    <ActiveImg></ActiveImg>
                </Display>
            </div>
        );
    });
};

const ApartSkillList = (props) => {
    const [isShowCurMoreSkill, setIsShowCurMoreSkill] = useState(false);
    const [expand, setExpand] = useState(false);
    const [open, setOpen] = useState(false);
    const { skillList = [], curSkill = {}, isNewChat = true, isInChat = true, chatBoxRef } = props;

    const [list, setList] = useState({
        showList: [],
        moreList: [],
        selectMoreList: []
    });
    const setSkill = (data) => {
        setList({ ...list, ...data });
    };
    //点击技能
    const handleSetCurSkill = (item) => {
        if (props.setCurSkill) {
            props.setCurSkill(item);
        }
    };
    //点击更多技能项
    const handleClickMoreSkill = (item) => {
        setOpen(false);
        handleSetCurSkill(item);
    };
    // 处理更多和展示的技能列表
    const handleList = (data) => {
        let showList = data.slice(0, 4);
        let moreList = data.slice(4, data.length);
        setSkill({ showList, moreList });
    };
    // 初始化
    useEffect(() => {
        handleList(skillList);
    }, [skillList]);

    const closeMore = () => {
        setOpen(false);
    };
    const toggleExpand = () => {
        if (!expand) {
            closeMore();
        }
        setExpand(!expand);
    };
    //更多技能选中后显示在更多上面
    useEffect(() => {
        if (!isNewChat || !curSkill) {
            setIsShowCurMoreSkill(false);
            return;
        }
        let index = list.moreList.findIndex((item) => item.ability_id == curSkill?.ability_id);
        if (index > -1) {
            setIsShowCurMoreSkill(true);
        } else {
            setIsShowCurMoreSkill(false);
        }
    }, [isNewChat, curSkill]);
    return (
        <div className={'left-skill-box'}>
            <RenderList
                isNewChat={isNewChat}
                isInChat={isInChat}
                handleSetCurSkill={handleSetCurSkill}
                curSkill={curSkill}
                list={list.showList}
            ></RenderList>
            <Display show={isShowCurMoreSkill && !expand}>
                <div data-active={true} className={'list-item'}>
                    <span className="skill-name">
                        <MyIcon className="skill-icon" type={curSkill?.ability_icon || 'icon-skill-icon1'}></MyIcon>

                        {curSkill?.ability_name}
                    </span>
                </div>
            </Display>

            <Display show={list.moreList.length}>
                <Popover
                    getPopupContainer={() => {
                        return chatBoxRef.current;
                    }}
                    onOpenChange={(flag) => {
                        if (!expand) {
                            setOpen(flag);
                        }
                    }} // 让Ant Design控制open状态
                    arrow={false}
                    rootClassName="more-skill-box"
                    placement="right"
                    open={open}
                    content={
                        <RenderList
                            isInChat={isInChat}
                            isInMore={true}
                            closeMore={closeMore}
                            isNewChat={isNewChat}
                            handleSetCurSkill={handleClickMoreSkill}
                            curSkill={curSkill}
                            list={list.moreList}
                        ></RenderList>
                    }
                    // open={open}
                    trigger="hover"
                >
                    <div data-more="true" data-expand={expand} onClick={toggleExpand} className={'list-item'}>
                        <span className={'more-item'} data-expand={expand}>
                            <MyIcon className="skill-icon" type="icon-more-skill"></MyIcon>
                            {expand ? '收起' : '更多'}
                        </span>
                        <MyIcon style={{ color: '#999999' }} type="icon-right" className={expand ? 'expand' : 'unexpand'}></MyIcon>
                        {/* {expand ? <DownOutlined /> : <RightOutlined />} */}
                    </div>
                </Popover>
            </Display>
            <Display show={expand}>
                <RenderList
                    isInChat={isInChat}
                    isInMore={false}
                    isNewChat={isNewChat}
                    handleSetCurSkill={handleSetCurSkill}
                    curSkill={curSkill}
                    list={list.moreList}
                ></RenderList>
            </Display>
        </div>
    );
};
export default memo(ApartSkillList);
